module.exports = __webpack_public_path__ + "img/user-journey.9869b64d.svg";